module.exports = __webpack_public_path__ + "img/panorama.d128b942.png";